import { Stack, useTheme } from "@mui/material";
import { User } from "lucide-react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { usePersonalDataFields } from "web_myplann/Profile/Hooks/usePersonalDataFields";
import { DataRowCard } from "web_myplann/Shared/Components/DataRowCard";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const PersonalDataAndAccountsPage = () => {
	const theme = useTheme();
	const { t } = useResource();

	const { fields } = usePersonalDataFields();

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={t(Resources.PersonalDataAndAccounts.title)}
					defaultRoute={Routing.Dashboard.path()}
				/>
			}
		>
			<Stack p={1.6}>
				<DataRowCard
					icon={<User color={theme.palette.deprecated.grey[700]} />}
					label={t(Resources.PersonalDataAndAccounts.PersonalData.title)}
					noDivider
					items={fields}
				/>
			</Stack>
		</MyPlannLayout>
	);
};
